
  <!-- content begin -->
  <div id="content" class="no-bottom no-top">
    <div id="top"></div>


  <!-- section begin -->
  <section id="subheader" class="text-light" data-bgimage="url(assets/images/background/10.jpg)" data-stellar-background-ratio=".2" style="background: url(assets/images/background/16.jpg) 0% 0px / cover; " >
    <div class="overlay-bg t50" style="background: rgba(30, 30, 30, .5)">

        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <h1>About the post</h1>
                </div>
            </div>
        </div>

    </div>

</section>
<!-- section close -->



<div class="row notifi_main ">
  <div class="col-md-12">
<h2>
  Senior Consultant - SANKALP
</h2>

<p class="para_main_notify">
  Skills Acquisition and Knowledge Awareness for Livelihood Promotion (SANKALP) is an outcome-oriented centrally sponsored program supported by World Bank.
</p>
  </div>
</div>


    <!-- section begin -->
    <section id="section-services">
        <div class="container">

            <div class="row align-items-center">
    <div class="col-md-12">
      <div class="row sequence">


                    <!-- feature box begin -->
                    <div class="col-md-12 feature-box mb40 sq-item wow">
                      <div class="feature-box style-2 left">
                        <i class="fa fa-tasks" aria-hidden="true"></i>
                        <div class="text para_cls">
                          <h3>	Project Background:</h3>
                          <p> SANKALP focuses on the overall skilling ecosystem covering both Central and State agencies, and outcomes are measured through Disbursement Linked Indicators (DLIs) agreed between MSDE and the World Bank. Under SANKALP the following key result areas have been identified viz: </p>
                            <p> <span class="step_no">1</span>Creating and building capacities of the institutions involved in planning and delivery of skill development at national, states and district levels  </p>
                            <p> <span class="step_no">2</span>	Quality Assurance of skill development programs for better outcomes  </p>
                            <p> <span class="step_no">3</span>	Inclusion of marginalised in skill development  </p>
                        </div>
                      </div>
                    </div>
                    <!-- feature box close -->

            <!-- feature box begin -->
            <div class="col-md-12 feature-box mb40 sq-item wow">
              <div class="feature-box style-2 left">
                <i class="fa fa-gavel" aria-hidden="true"></i>
                <div class="text para_cls">
                  <h3>	Key responsibilities::</h3>
                  <p> <b> Senior Consultantshall be overall responsible for the following activities: </b> </p>
                    <p> <span class="step_no">1</span>Design and support MSDE in undertaking different assignments (like impact assessment, coordinating workshops etc) as per requirement.  </p>
                    <p> <span class="step_no">2</span>	Prepare concept notes and project specific documents  </p>
                    <p> <span class="step_no">3</span>	Concurrent monitoring of ongoing research projects  </p>
                    <p> <span class="step_no">4</span>	Support States/ UTs in undertaking research studies as approved under SANKALP.  </p>
                    <p> <span class="step_no">5</span>	Preparing concept notes, analytical reports and other project and policy documents.  </p>
                    <p> <span class="step_no">6</span>	Supporting MSDE in undertaking procurements following applicable procurement
                      norms  </p>
                    <p> <span class="step_no">7</span>	Any other work as per MSDErequirement.  </p>


                </div>
              </div>
            </div>
            <!-- feature box close -->

        <!-- feature box begin -->
        <div class="col-md-12 mb40 sq-item wow sq-item wow">
          <div class="feature-box style-2 left">
            <i class="fa fa-graduation-cap"></i>
            <div class="text para_cls">
              <h3>Qualification: </h3>
              <p> <span class="step_no">1</span>Bachelors in Statistics, Technology, Economics or equivalent. Candidates with Masters in Economics, Statistics or MBA will be given preference  </p>

            </div>
          </div>
        </div>
        <!-- feature box close -->




  <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-history"></i>
      <div class="text para_cls">
        <h3>Experience:</h3>
        <p> <span class="step_no">1</span> Atleast 10+ years of relevant experience  </p>
        <p> <span class="step_no">2</span>	Preference will be given to candidates having prior experience of working with Government of India/ State Governments/ World Bank and having exposure to procurement.  </p>
        <p> <b> In exceptional cases candidate with lower qualifications/ experience can also be considered. </b> </p>
      </div>
    </div>
  </div>
  <!-- feature box close -->

  <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-money"></i>
      <div class="text para_cls">
        <h3>Remuneration:</h3>
        <p> Remuneration to the Technical Resources shall be commensurate with their experience and last drawn salary.        </p>
        <p> Remuneration Range in Rs 1.5 to 3 lakh per month        </p>
      </div>
    </div>
  </div>
  <!-- feature box close -->
  <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-calendar"></i>
      <div class="text para_cls">
        <h3>Last Date:</h3>
        <p style="color: red;"><b> Last date for Applying Online 27th April 2021 </b> </p>
      </div>
    </div>
  </div>
  <!-- feature box close -->

  <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-cogs"></i>
      <div class="text para_cls">
        <h3>Skills and Competencies:</h3>
        <p><span class="step_no">1</span>Strong analytical and documentation skills;</p>
        <p><span class="step_no">2</span>Should have experience implementing projects in multi stakeholder environment</p>
        <p><span class="step_no">3</span>Should have designed/carried out studies and research projects in skilling and
          livelihood</p>
        <p><span class="step_no">4</span>Experience conducting training workshops and capacity building programs</p>
        <p><span class="step_no">5</span>StrWillingness and ability to travel extensively;</p>
        <p><span class="step_no">6</span>Should be able to operate in unstructured environment with minimal support.</p>


      </div>
    </div>
  </div>
  <!-- feature box close -->

  <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-globe"></i>
      <div class="text para_cls">
        <h3>Nature of engagement:</h3>
        <p><span class="step_no">1</span>Annual contract with performance based extension of contract as per
          project requirement.</p>


      </div>
    </div>
  </div>
  <!-- feature box close -->
<!--
  <div class="col-md-12 feature-box mb40 sq-item wow" style="text-align: center;">
    <a href="http://nimiprojects.in/recruitment/register.php" target="_blank" class="btn-custom scroll-to">Apply Now</a>
</div> -->


  <div class="container big_padd">








      </div>


    </div>
    <!-- content close -->




    <style>
      #section-intro{
        background-image: url(assets/images/background/niminew.jpg);
    background-size: cover;
    background-position: 0% 0px;
    height: 80vh !important;
      }
      .notifi_main{
        text-align: center;
        padding: 40px 0px;
      }

      .notifi_main h2{
        border-bottom: 6px solid #F56B55;
    width: fit-content;
    margin: 0 auto;
    padding: 0px 30px;
      }
      .notifi_main .descrip_cls{
        padding: 5px 0px;
    font-weight: 500;
    font-size: 21px;
      }

      .overlay-bg.t50{
        background: rgba(30, 30, 30, .1);
      }

      table{
      width: 100%;
      margin-top: 10px;
    }
    th, td{
      padding: 10px;
    }
    thead{
      background-color: #F56B55;
      color: #fff;
    }
    tr:nth-child(odd){
      background-color: #eee;
    }
    .step_no{
      left: 80px;
    height: 30px;
    width: 30px;
    background-color: #F56B55;
    border-radius: 50%;
    display: inline-block;
    font-size: 18px;
    text-align: center;
    color: #fff;
    margin-right: 10px;
    position: absolute;
    }

    .para_cls p{
      padding-left: 35px;
    }
    .num_marks{
      text-align: center;
    }
    .last_tr{
      background-color: #F56B55 !important;
      color: #fff;
    }
    .notifi_main_table h2{

    width: fit-content;
    margin: 0 auto;
    padding: 50px 30px 10px;
    font-size: 23px;

    }
    .para_main_notify{
      padding: 20px 0px;
    width: 50%;
    margin: 0 auto;
    }
  #section-services{
      padding: 0px !important;
    }
    </style>
